var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.00146C0 1.34461 1.34315 0.00146484 3 0.00146484L15 0.00146484C15.5523 0.00146484 16 0.44918 16 1.00146C16 1.55375 15.5523 2.00146 15 2.00146L3 2.00146C2.44772 2.00146 2 2.44918 2 3.00146C2 3.55375 2.44772 4.00146 3 4.00146L15 4.00146C15.5523 4.00146 16 4.44918 16 5.00146C16 5.55375 15.5523 6.00146 15 6.00146L3 6.00146C1.34315 6.00146 0 4.65832 0 3.00146Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5015L0 3.00146L2 3.00146L2 14.0015L14 14.0015L14 5.00146L16 5.00146L16 14.5015C16 15.3299 15.3284 16.0015 14.5 16.0015H1.5C0.671572 16.0015 0 15.3299 0 14.5015Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.00146V1.00146L14 1.00146V5.00146H12Z",
    fill: "#242424"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.00146,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.7f8b31f4281b148b59c8a02e89e881ea.svg";
export { ForwardRef as ReactComponent };